<template>

    <div class="w-full -mx-3">

        <div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6 mx-3">
			<div class="w-full py-3 px-4 md:w-auto -mb-3 md:mb-0">
				<router-link tag="button" to="/admin/sales/add" class="bg-green-600 text-white rounded px-2 py-1">
                    Add Sale
                </router-link>
			</div>
            
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<router-link tag="button" to="/admin/sales/pending" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Pending Sales
				</router-link>
				<router-link tag="button" to="/admin/sales/processing" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Processing Sales
				</router-link>
				<!-- <router-link tag="button" to="/admin/sales/completed" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Completed Sales
				</router-link> -->
                <router-link tag="button" to="/admin/sales/search" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Sale Search
				</router-link>
			</div>
		</div>

        <Card class="w-full mb-6 mx-3">
            <template v-slot:header>
                Add Sale
            </template>
            <template v-slot:body>
                
                <div class="p-6 clearfix">

                    <div class="md:flex md:items-center mb-6 mt-6">
                        <div class="md:w-1/3">
                            <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                                Stringer
                            </label>
                        </div>
                        <div class="md:w-2/3">
                            <v-select :debounce="250" @search="getSearchUsers" :options="userCollection" v-model="user" placeholder="Search for a user..." label="name"></v-select>
                        </div>
                    </div>

                    <div class="md:flex md:items-center mb-6 mt-6">
                        <div class="md:w-1/3">
                            <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                                Video
                            </label>
                        </div>
                        <div class="md:w-2/3">
                            <v-select :debounce="250" @search="getSearchVideos" :options="videoCollection" v-model="video" placeholder="Search for a users video..." label="title"></v-select>
                        </div>
                    </div>

                    <div class="md:flex md:items-center mb-6 mt-6">
                        <div class="md:w-1/3">
                            <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                                Purchasing Network
                            </label>
                        </div>
                        <div class="md:w-2/3">
                            <label class="dropdown_wrap">
                                <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="network">
                                    <option v-for="network in networks" :value="network.id">{{ network.name }}</option>
                                </select>
                            </label>
                        </div>
                    </div>

                    <div class="md:flex md:items-center mb-6 mt-6">
                        <div class="md:w-1/3">
                            <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                                Purchasing User
                            </label>
                        </div>
                        <div class="md:w-2/3">
                            <v-select :debounce="250" @search="getNetworkUsers" :options="networkUserCollection" v-model="networkUser" placeholder="Search for a network user..." label="name"></v-select>
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Sale Price</label>
                        <div class="flex flex-wrap items-stretch w-full mb-4 relative">
                            <div class="flex -mr-px">
                                <span class="flex items-center leading-normal bg-gray-200 rounded rounded-r-none border-2 border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-darker text-sm font-bold">$</span>
                            </div>				
                            <input type="number" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-2 rounded rounded-l-none h-10 border-grey-light px-3 relative bg-grey-lighter focus:outline-none focus:border-gray-darkest focus:bg-white" v-model="price">
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Stringer Amount</label>
                        <div class="flex flex-wrap items-stretch w-full mb-4 relative">
                            <div class="flex -mr-px">
                                <span class="flex items-center leading-normal bg-gray-200 rounded rounded-r-none border-2 border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-darker text-sm font-bold">$</span>
                            </div>				
                            <input type="number" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-2 rounded rounded-l-none h-10 border-grey-light px-3 relative bg-grey-lighter focus:outline-none focus:border-gray-darkest focus:bg-white" v-model="stringerAmount">
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Invoice Number</label>
                        <div class="col-sm-7">
                            <input type="number" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="name" v-model="invoiceNumber">
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Sale Date <small>format: mm-dd-yyyy</small></label>
                        <div class="col-sm-7">
                            <input type="text" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="name" v-model="saleDate">
                        </div>
                    </div>


                    <button class="px-2 py-1 bg-blue-700 rounded text-white text-md float-right" v-on:click="addSale">Add Sale</button>

                </div>

            </template>
        </Card>
    </div>
    		
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    
    import Card from '@/components/partials/Card'

    export default {
        data() {
            return {
                userCollection: [],
                videoCollection: [],
                networkUserCollection: [],
                networks: [],

                data: [],
        
                networkUser: null,
                user: null,
                video: null,
                network: null,

                price: null,
                invoiceNumber: null,
                stringerAmount: null,
                saleDate: null,
            }
        },

        components: {
            Card
		},

        mounted() {
            this.loadNetworks();
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            addSale() {

                var data = {
                    video_id: this.video.id,
                    price: this.price,
                    stringer_amount: this.stringerAmount,
                    network: this.network,
                    network_user: this.networkUser.id,
                    invoice: this.invoiceNumber,
                    saleDate: this.saleDate,
                }

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/sales/manual", data, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {
                        _this.$swal(
                            'Sale added.',
                            null,
                            'success'
                        )
                        _this.resetFields();
                    }
                });
            },

            getSearchUsers(search, loading) {
                loading(true)

                var data = {
                    name: search,
                }

                this.$http.post(Config.apiPath + '/api/v2/admin/users/search/stringers', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.userCollection = response.data;
                        loading(false)
                    })
            },

            getSearchVideos(search, loading) {
                loading(true)

                if(this.user !== null) {
                    var data = {
                        search: search,
                        user_id: this.user.id,
                    }
                } else {
                    var data = {
                        search: search,
                    }
                }
                

                this.$http.post(Config.apiPath + '/api/v2/admin/videos/search', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.videoCollection = response.data;
                        loading(false)
                    })
            },

            getNetworkUsers(search, loading) {
                loading(true)

                var data = {
                    name: search,
                    network_id: this.network,
                }

                this.$http.post(Config.apiPath + '/api/v2/admin/users/search/media', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.networkUserCollection = response.data;
                        loading(false)
                    })
            },

            loadNetworks() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/networks", this.getAuthorizationHeader()).then((response) => {
                    _this.networks = response.data
                });

            },

            resetFields() {
                this.userCollection = null
                this.videoCollection = null
                this.networkUserCollection = null

                this.data = {}
        
                this.networkUser = null
                this.user = null
                this.video = null
                this.network = null

                this.price = null
                this.invoiceNumbe = null
                this.stringerAmount = null
                this.saleDate = null
            }

        },
        watch: {
            video: function(data) {
                this.price = data.price;
            }
        }
    }
</script>

<style scoped>

</style>
